import { useQuery } from '@tanstack/react-query';

import { INCOME_RULE_ID } from '~/common/constants';
import useUrl from '~/common/hooks/useUrl';
import { typedApiClient } from '~/common/util/api-client';
import { CATEGORY_IDS } from '~/pages/Home/constants';

async function getNavigationDetails({ queryKey }) {
  const [, obfuscatedLoanIdentifier] = queryKey;

  const { data } = await typedApiClient.v1.loanGetNavigationDetails(
    obfuscatedLoanIdentifier,
  );

  return data;
}

function filterGutterItemsForReviewBreakdown(data) {
  const SHOW_REVIEW_BREAKDOWN_RULES = new Set([
    INCOME_RULE_ID.INCOME_REVIEW_BREAKDOWN_RULE_ID,
    INCOME_RULE_ID.REVIEW_BREAKDOWN_YAML_RULE_ID,
    INCOME_RULE_ID.RENTAL_INCOME_CALCULATION_RULE_ID,
  ]);
  const incomeNavItems = data.topNavigationItems.find(
    ({ navigationCategoryId }) => navigationCategoryId === CATEGORY_IDS.INCOME,
  )?.navigationGutterItems;

  if (!incomeNavItems) return [];

  return incomeNavItems
    .flatMap(({ displayTitle, parentRuleSortOrder, gutterItemChildren }) =>
      gutterItemChildren
        .filter(({ ruleId }) => SHOW_REVIEW_BREAKDOWN_RULES.has(ruleId))
        .map((item) => ({
          ...item,
          parentTitle: displayTitle,
          parentRuleSortOrder,
        })),
    )
    .concat(
      incomeNavItems
        .filter(
          ({ additionalReferences }) =>
            additionalReferences.IsNoCalcEmployer === 'True',
        )
        .map((item) => ({ ...item, parentTitle: item.displayTitle })),
    )
    .sort((a, b) => a.parentRuleSortOrder - b.parentRuleSortOrder);
}

export function useGetNavigationDetails() {
  const { obfuscatedLoanIdentifier } = useUrl();
  return useQuery({
    queryKey: ['getNavigationDetail', obfuscatedLoanIdentifier],
    queryFn: getNavigationDetails,
    select: filterGutterItemsForReviewBreakdown,
  });
}
